import React, { FunctionComponent, useCallback } from 'react'
import { ID } from '../../../types/UtilityTypes'
import { EMPTY_TASK, PartialTask, Task } from '../../../responses/tasks'
import { PERMISSIONS } from '../../../constants/permissions'
import TaskEdit from '../../pages/projects/ProjectPage/tasks/TaskEdit/TaskEdit'
import { taskActions } from '../../../redux/data/task/task-actions'
import TaskRequest from '../../pages/projects/ProjectPage/tasks/TaskRequest/TaskRequest'
import { TaskStatus } from '../../../constants/enums'
import TaskBody from '../../pages/projects/ProjectPage/tasks/TaskBody/TaskBody'
import { useAllPermissions, useRootDispatch, useRootSelector } from '../../../utils/hooks'
import { TaskEditState } from '../../../redux/data/task/task-reducer'

interface Props {
    task: Task,
    parentId?: ID,
    objectId: ID,
    projectId: ID,
    hideLink?: boolean,
}

const TaskContent: FunctionComponent<Props> = props => {
    const dispatch = useRootDispatch()
    const editState = useRootSelector(state => state.data.task.editState)
    const user = useRootSelector(state => state.global.user.data)

    const canOpen = useAllPermissions([PERMISSIONS.TASK.OPEN])
    const canRequest = useAllPermissions([PERMISSIONS.TASK.REQUEST])

    const update = useCallback((changes: PartialTask) => dispatch(taskActions.update.request({
        id: props.task.id,
        ...changes,
    })), [dispatch, props.task.id])

    if (TaskEditState.is.append(editState) &&
        editState.parentId === props.parentId &&
        props.task.id == EMPTY_TASK.id) {
        if (canOpen) {
            return <TaskEdit
                key={'append-edit'}
                actionText={'Добавить'}
                projectId={props.projectId}
                onCancel={() => dispatch(taskActions.cancelEdit())}
                onSuccess={created => dispatch(taskActions.create.request({
                    objectId: props.objectId,
                    parentId: props.parentId,
                    task: created,
                }))}
            />
        } else {
            if (canRequest) {
                return <TaskRequest
                    key={'append-request'}
                    edit
                    onOk={created => dispatch(taskActions.create.request({
                        task: created,
                        parentId: props.parentId,
                        objectId: props.objectId,
                    }))}
                    onCancel={() => dispatch(taskActions.cancelEdit())}
                />
            }
        }
    }

    if (TaskEditState.is.update(editState) && editState.task.id == props.task.id) {
        return <TaskEdit
            key={'update'}
            projectId={props.projectId}
            actionText={'Изменить'}
            task={props.task}
            onCancel={() => dispatch(taskActions.cancelEdit())}
            onSuccess={update}
        />
    }

    if (props.task.status_id === TaskStatus.REQUESTED) {
        if (canOpen) {
            return <TaskEdit
                key={'request-edit'}
                task={props.task}
                projectId={props.projectId}
                actionText={'Открыть'}
                onSuccess={task => update({
                    ...task,
                    status_id: TaskStatus.OPENED,
                })}
                onCancel={() => dispatch(taskActions.startDelete({
                    message: 'Подтвердите отмену запроса',
                    task: props.task,
                }))}
            />
        } else {
            if (props.task.details.user_id === user?.id) {
                return <TaskRequest
                    key={'request-request'}
                    task={props.task}
                    onOk={created => dispatch(taskActions.create.request({
                        task: created,
                        parentId: props.parentId,
                        objectId: props.objectId,
                    }))}
                    onCancel={() => dispatch(taskActions.startDelete({
                        message: 'Подтвердите отмену запроса',
                        task: props.task,
                    }))}
                    onUpdate={update}
                />
            }
        }
    }

    return <TaskBody
        key={'body'}
        task={props.task}
        projectId={props.projectId}
        hideLink={props.hideLink}
        onUpdate={update}
    />
}

export default TaskContent